module.exports = __webpack_public_path__ + "ps.svg?930fc9498126d3f29f21fb79dee9295a";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ps.svg
// module id = 1358
// module chunks = 27